import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    studentInfoShow: false, // 是否显示修改学生信息弹窗
    studentInfo: '', // 学生全部信息
    userInfo: '' // 当前选中学校的学生信息
  },
  mutations: {
    changeStuInfoShow(state, e) {
      state.studentInfoShow = e
    },
    getStudentInfo(state, data) {
      state.studentInfo = data
    },
    setUserInfo(state, data) {
      state.userInfo = data
    },
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js